import FpuiCanvasIcon from './FpuiCanvasIcon'
import FpuiCanvasMode from './FpuiCanvasMode'

export {
  FpuiCanvasIcon,
  FpuiCanvasMode
}

export default FpuiCanvasIcon
